<mat-label class="subHeading ">Payout Type<span class="star">*</span></mat-label>

<mat-select formControlName="payout_type" placeholder="Select">
    <mat-option value="percentage">Percentage</mat-option>
    <mat-option value="flat">Flat Amount</mat-option>
</mat-select>